<template>
  <div>
    <div class="w-100 d-inline-block 
    pets-banner-slider">
      <div class="container-fluid">
        <div class="row">
          <div class="col-xl-3 d-xl-block d-none">
            <div class="w-100 d-inline-block text-center margin-top-4">
              <img class="w-60" src="@/assets/images/banner-small-image.svg" alt="picture">
            </div>
            <div class="w-100 d-inline-block 
            margin-top-4">
              <img class="w-60" src="@/assets/images/banner-small-image-2.svg" alt="picture">
            </div>
          </div>
          <div class="col-xl-6 col-12 col-sm-7 
          col-md-7">
             <div class="w-100 d-inline-block home-banner-heading text-center">
               <h1 class="half-black fw-bold filson-black-family text-capitalize">
                {{ headingOne }}
              </h1>
              <p class="text-black text-size-15 margin-bottom-3 inter-regular-family margin-xl-top-3 text-full-14">
                {{ contentOne }}
              </p>
              <div class="w-100 d-inline-block text-xs-center">
                <router-link class="text-white text-size-14 d-inline-block book-online-btn border-yellow bg-yellow inter-bold-family me-2 text-full-11" to="/booking/">
                  <img src="@/assets/images/book-online-icon.svg" alt="picture" class="me-2 h-16">
                  BOOK NOW
              </router-link>
              <a class="text-white text-size-14 d-inline-block bg-call inter-bold-family whats-btn text-uppercase text-full-11" href="javascript:void(0)" @click="openWhatsApp">
                <i class="fa fa-whatsapp text-size-20 text-full-18 me-2 float-start" aria-hidden="true"></i>
                WhatsApp 
              </a>
              </div>
             </div>
          </div>
          <div class="col-xl-3 d-xl-block d-none">
            <div class="w-100 d-inline-block text-center margin-top-4">
              <img class="w-60" src="@/assets/images/banner-small-image-3.svg" alt="picture">
            </div>
            <div class="w-100 d-inline-block 
            margin-top-4">
              <img class="w-60" src="@/assets/images/banner-small-image-4.svg" alt="picture">
            </div>
          </div>
          <!-- <div class="col-xl-6 col-12 col-sm-5 mt-sm-5 mt-xl-0 col-md-5">
            <div class="w-100 d-inline-block banner-pets-image text-center mt-1 mb-1 mt-sm-5 mt-xl-0 mt-md-0 mb-xl-0 mb-5 mb-sm-0 mb-md-0">
              <img class="w-100" v-lazy="require('@/assets/images/pet-grooming-pet-groomer.webp')" alt="pet grooming, pet groomer">
            </div>
          </div> -->
        </div>
      </div>
  </div>
  </div>
</template>

<script>
export default {
  name: 'bannerComponent',
  data() {
    return {
      headingOne: 'Book Best Mobile Pet Grooming Service In Dubai With Us',
      contentOne:
        "Are you a pet lover and looking for the best pet groomer in Dubai for your buddy? We are here to offer a wide range of mobile pet grooming services designed to meet your pet's needs.",
    };
  },
  methods: {
    replaceDubai(s) {
      const name = (this.$countryName || '').toString().trim();
      if (!name) return s;
      return String(s).replace(/dubai/gi, name);
    },
    async fetchHomePage() {
      try {
        const res = await this.$axios.post('/get-home-page', {
          website_name: this.activeWebsiteName,
        });
        const page = res?.data?.home_page;
        if (!page) return;
        this.headingOne = this.replaceDubai(page.heading_one || this.headingOne);
        this.contentOne = this.replaceDubai(page.content_one || this.contentOne);
      } catch (e) {
        // keep defaults (no UI changes)
        console.error('fetchHomePage', e);
      }
    },
    openWhatsApp() {
      this.callClick();
      window.dispatchEvent(new CustomEvent('open-whatsapp-chat'));
    },
    async callClick() {
      try {
        const payload = {
          website_name: this.activeWebsiteName,
          type: 'whatsapp',
        };
        await this.$axios.post('/click-count', payload);
      } catch (err) {
        console.error('Error during call click:', err);
      }
    },
  },
  mounted() {
    // Ensure defaults are dynamic even if API fails
    this.headingOne = this.replaceDubai(this.headingOne);
    this.contentOne = this.replaceDubai(this.contentOne);
    this.fetchHomePage();
  },
  watch: {
    activeWebsiteName() {
      this.fetchHomePage();
    },
  },
};
</script>

<style scoped>
/* Add styles specific to this component here */
</style>
